export class Grupo {
  constructor({
    id = null,
    nome = null,
    descricao = null,
    origem = null,
    origemId = null,
    disciplinaId = null,
    disciplina = null,
    funcaoId = null,
    funcao = null,
    greId = null,
    gre = null,
    secretariaId = null,
    secretaria = null,
    setorId = null,
    setor = null,
    usuarios = [],
  }) {
    this.id = id;
    this.nome = nome;
    this.descricao = descricao;
    this.origem = origem;
    this.origemId = origemId;
    this.disciplinaId = disciplinaId;
    this.disciplina = disciplina;
    this.funcaoId = funcaoId;
    this.funcao = funcao;
    this.greId = greId;
    this.gre = gre;
    this.secretariaId = secretariaId;
    this.secretaria = secretaria;
    this.setorId = setorId;
    this.setor = setor;
    this.usuarios = usuarios;
  }
  static Build() {
    return new Grupo({
      id: null,
      nome: null,
      descricao: null,
      origem: null,
      origemId: null,
      disciplinaId: null,
      disciplina: null,
      funcaoId: null,
      funcao: null,
      greId: null,
      gre: null,
      secretariaId: null,
      secretaria: null,
      setorId: null,
      setor: null,
      usuarios: [],
    });
  }
  formatParaEnviar() {
    return {
      ...this,
      origemId: this.origem?.id,
      origem: this.origem?.descricao || this.origem?.nome,
      disciplina: this.disciplina?.nome,
      funcao: this.funcao?.nome,
      gre: this.gre?.nome,
      secretaria: this.secretaria?.nome,
      setor: this.setor?.nome,
      usuarios: this.usuarios.map((usuario) => usuario.id || usuario.usuarioId),
    };
  }
}
